<div class="workflow-page">
  <h2 class="workflow-title">AFib Workflow</h2>

  <div class="workflow-card">
    <img
      src="assets/workflow_image.png"
      alt="AFib referral and waitlist workflow"
      class="workflow-image"
    />
  </div>
</div>